export default "__VITE_ASSET__CW0C0Bam__"